<!--
   Created by qing on 2021/1/23
   Des: 
-->
<template>
  <div>
    <van-cell class="ry-form__digital" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{currentRow[dataId]}}{{current.showUnit}}
        </div>
        <van-field
          v-if="!isRead"
          type="number"
          readonly
          @change="valueChange"
          v-model="currentRow[current.dataId]"
          :placeholder="current.fieldDes || '请填写内容'"
          :error-message="errorMessage">
          <div slot="extra" style="display: flex">
            <div style="display: flex; align-items: center;">{{current.showUnit}}</div>
          </div>
        </van-field>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__digital-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{currentRow[dataId]}}{{current.showUnit}}
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        type="number"
        readonly
        @change="valueChange"
        v-model="currentRow[current.dataId]"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请填写内容'"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <div slot="extra" style="display: flex">
          <div style="display: flex; align-items: center;">{{current.showUnit}}</div>
        </div>
      </van-field>
    </div>

  </div>

</template>

<script>
  import {current} from './mixin'
  import {TRIGGER_TYPE_BLUR, TRIGGER_TYPE_FOCUS, TRIGGER_TYPE_BUTTON} from "../../types";

  export default {
    mixins: [current],
    data() {
      return {
        TRIGGER_TYPE_BUTTON,
        isError: false,
        oldValue: 0
      }
    },
    created() {
      this.oldValue = this.current.value
    },
    computed: {
      content: {
        set(newVal) {
          this.currentRow[this.current.dataId] = Number(newVal)
          // .replace(/[^\d.]/g, "")   // 清除“数字”和“.”以外的字符
          // .replace(/^\./g, "")      // 验证第一个字符是数字而不是.
          // .replace(".", "$#$")
          // .replace(/\./g, "")
          // .replace("$#$", ".")
        },
        get() {
          return String(this.currentRow[this.current.dataId])
        }
      },
      checkList() {
        return this.current.checkList()
      },
      errorMessage() {
        return this.isError ? this.current.requiredShowText : ''
      }
    },
    methods: {
      valueChange() {
        this.currentRow[this.current.dataId] = Number(this.currentRow[this.current.dataId])
        this.controlChange()
      }
    }
  }
</script>

<style lang="less">

  .ry-form__digital {

    .btn {
      padding: 0 !important;

      .van-field__body {
        margin-right: 0 !important;

        .van-field__button {
          height: auto;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>